@let controls = formGroup().controls;

<app-form-line [widthVariant]="widthVariant()">
  <nz-form-item>
    <nz-form-label nzFor="password" nzRequired="true" nzNoColon="true">
      New password
    </nz-form-label>
    <nz-form-control [nzErrorTip]="passwordErrorTpl">
      <nz-input-group [nzSuffix]="passwordToggle">
        <input
          id="password"
          nz-input
          [type]="passwordVisible() ? 'text' : 'password'"
          [formControl]="controls.password"
          name="new-password"
          placeholder="Enter your new password"
          autocomplete="new-password"
        />
      </nz-input-group>
      <ng-template #passwordToggle>
        <nz-icon
          class="ant-input-password-icon new-password-fields__toggle-icon"
          [nzType]="passwordVisible() ? 'eye-invisible' : 'eye'"
          (click)="handleTogglePassword()"
        />
      </ng-template>
      <ng-template #passwordErrorTpl>
        @if (controls.password.hasError('required')) {
          <span>Please enter your new password</span>
        } @else if (controls.password.hasError('minlength')) {
          <span>Use at least {{ minLength }} characters</span>
        } @else if (controls.password.hasError('maxlength')) {
          <span>Use no more than {{ maxLength }} characters</span>
        } @else if (controls.password.hasError('passwordTooCommon')) {
          <span>Choose a less common password</span>
        } @else if (
          controls.password.hasError('passwordContainsRestrictedTerm')
        ) {
          <span>Avoid company or product names in your password</span>
        } @else if (
          controls.password.hasError('passwordContainsPersonalInfo')
        ) {
          <span>Avoid using your email or name in your password</span>
        }
      </ng-template>
      <div class="new-password-fields__hint">
        Use 12 to 128 characters. Passphrases are allowed.
      </div>
    </nz-form-control>
  </nz-form-item>
</app-form-line>

<app-form-line [widthVariant]="widthVariant()">
  <nz-form-item>
    <nz-form-label
      nzFor="passwordConfirmation"
      nzRequired="true"
      nzNoColon="true"
    >
      Confirm new password
    </nz-form-label>
    <nz-form-control [nzErrorTip]="passwordConfirmationErrorTpl">
      <nz-input-group [nzSuffix]="passwordConfirmationToggle">
        <input
          id="passwordConfirmation"
          nz-input
          [type]="confirmationVisible() ? 'text' : 'password'"
          [formControl]="controls.passwordConfirmation"
          name="new-password-confirmation"
          placeholder="Confirm your new password"
          autocomplete="new-password"
        />
      </nz-input-group>
      <ng-template #passwordConfirmationToggle>
        <nz-icon
          class="ant-input-password-icon new-password-fields__toggle-icon"
          [nzType]="confirmationVisible() ? 'eye-invisible' : 'eye'"
          (click)="handleToggleConfirmation()"
        />
      </ng-template>
      <ng-template #passwordConfirmationErrorTpl>
        @if (controls.passwordConfirmation.hasError('required')) {
          <span>Please confirm your new password</span>
        } @else if (
          controls.passwordConfirmation.hasError('passwordMismatch')
        ) {
          <span>Passwords must match</span>
        }
      </ng-template>
    </nz-form-control>
  </nz-form-item>
</app-form-line>
